import { useEffect, useState } from "react";
import "./AppPTOPolicies.css";
import { DC_COMPONENT_LABELS, PaidTimeOffPolicy } from "winslow-core";
import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData";
import { useNavigate } from "react-router-dom";
import { Button, Icon } from "../../../ds2/components";
import { Plus, Edit, Trash2, Eye } from "lucide-react";
import { AppPTOPolicyEditor, PTOPolicyTypeDescription } from "./AppPTOPolicyEditor";
import { useHRISLocation } from "../../../hooks/useHRISLocation";
import "../../../ds2/components/Table.css";

export type AppPTOPoliciesNavigationActions = "edit" | "new";

type AppPTOPoliciesProps = {
    ptoPolicies: PaidTimeOffPolicy[] | undefined;
    onNavigation?: (
        newObjectName: DC_COMPONENT_LABELS,
        newLabel: string,
        data: any
    ) => void;
    onCancel?: () => void;
    showAddingPolicy?: boolean;
}

export const AppPTOPolicies = ({ptoPolicies, onNavigation, showAddingPolicy = false, onCancel} : AppPTOPoliciesProps) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const uiStates = useSelector(selectUIStates);
    // const { location } = useHRISLocation("PTO Policies")
    const storeUser = useSelector(selectUser);
        
    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "PTO Policies"}));
    }, []);

    return (
        <div className="app-pto-policies">
            {showAddingPolicy &&
                <div className="pto-policy-new">
                    <AppPTOPolicyEditor
                        onCancel={onCancel}
                    />
                </div>
            }
            {!showAddingPolicy && ptoPolicies && ptoPolicies.length > 0 && (
                <div className="pto-policies-table-container">
                    <table className="ds2-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Effective Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ptoPolicies.map((ptoPolicy: PaidTimeOffPolicy) => (
                                <tr 
                                    key={ptoPolicy.id}
                                    className="pto-policy-row"
                                >
                                    <td className="pto-policy-name-cell">
                                        <strong>{ptoPolicy.name}</strong>
                                    </td>
                                    <td className="pto-policy-type-cell">
                                        {PTOPolicyTypeDescription[ptoPolicy.type]}
                                    </td>
                                    <td className="pto-policy-description-cell">
                                        {ptoPolicy.description || '-'}
                                    </td>
                                    <td className="pto-policy-effective-date-cell">
                                        {new Date(ptoPolicy.effectiveDate).toLocaleDateString()}
                                    </td>
                                    <td className="pto-policy-actions-cell">
                                        <div className="pto-policy-actions-group">
                                            <Icon
                                                variant="tertiary"
                                                size="sm"
                                                icon={<Eye size={14} />}
                                                onClick={() => {
                                                    onNavigation ?
                                                        onNavigation("pto-policy", "view", {paidTimeOffPolicyId: ptoPolicy.id}) :
                                                    navigate("/app/time-off/policy-viewer/" + ptoPolicy.id);
                                                }}
                                            />
                                            <Icon
                                                variant="tertiary"
                                                size="sm"
                                                icon={<Edit size={14} />}
                                                onClick={() => {
                                                    onNavigation ?
                                                        onNavigation("pto-policy", "edit", {paidTimeOffPolicyId: ptoPolicy.id}) :
                                                    navigate("/app/time-off/policy-editor/" + ptoPolicy.id);
                                                }}
                                            />
                                            <Icon
                                                variant="tertiary"
                                                size="sm"
                                                icon={<Trash2 size={14} />}
                                                onClick={() => {
                                                    // TODO: Implement delete functionality
                                                    console.log("Delete policy:", ptoPolicy.id);
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {ptoPolicies && ptoPolicies.length === 0 && (
                <div className="pto-policy-empty-state">
                    <div className="pto-policy-empty-message">
                        No PTO policies found
                    </div>
                    <div className="pto-policy-actions">
                        <Button
                            variant="primary"
                            leftIcon={<Plus size={16} />}
                            onClick={() => {
                                onNavigation ? 
                                    onNavigation("pto-policy", "new", {paidTimeOffPolicyId: "new"}) :
                                    navigate("/app/time-off/policy-editor/new");
                            }}
                        >
                            Add Policy
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};